import { useEffect } from "react";
import { IDLE_TIMEOUT_MINUTES } from "@/lib/constants";

const EVENTS = ["mousemove", "mousedown", "keydown", "touchstart", "scroll"];

export const useIdleLogout = (onIdle, minutes = IDLE_TIMEOUT_MINUTES) => {
  useEffect(() => {
    let timer;
    const reset = () => {
      clearTimeout(timer);
      timer = setTimeout(onIdle, minutes * 60 * 1000);
    };
    EVENTS.forEach((evt) => window.addEventListener(evt, reset, { passive: true }));
    reset();
    return () => {
      clearTimeout(timer);
      EVENTS.forEach((evt) => window.removeEventListener(evt, reset));
    };
  }, [onIdle, minutes]);
};
